import { Button, styled } from '@material-ui/core';

/** @deprecated Legacy MUI copy - migrate consumers to the Encore Section and delete. */
const SectionButtonMui = styled(Button)({ padding: 0, minWidth: 'auto' });

export default SectionButtonMui;
